import requests from '../requests'
import actions from './actions'

export const operationFetchMembershipInfo = () => async (dispatch) => {
  dispatch(actions.fetchMembershipInfoStart())
  try {
    const response = await requests.fetchMemberInfo()
    dispatch(actions.fetchMembershipInfoSuccess(response))
  } catch (error) {
    dispatch(actions.fetchMembershipInfoFail())
  }
}
